export const app_data = {
	"a2048": {
		module: window.a2048_module,
		title: "2048",
		description: `I recreated the popular mobile game 2048 from scratch, without any assistance from tutorials, game engines, libraries, or frameworks.

		This challenging puzzle game requires players to swipe tiles on a grid, combining like numbers to increase their value. The goal is to reach the coveted 2048 tile, but be careful not to run out of moves!

		Controls:
		• Swipe on the touch screens
		• Arrow Keys
		• WASD Keys`,
		url: "https://github.com/uplinkx/2048",
		aspect_ratio: 1/1,
		console: false,
	},
	"chess": {
		module: window.chess_module,
		title: "Chess",
		description: "Small game of chess. Click on pieces and move them around",
		url: "https://github.com/uplinkx/chess",
		aspect_ratio: 1/1,
		console: false,
	},
	"flappy_bird": {
		module: window.flappy_bird_module,
		title: "Flappy Bird",
		description: `Flappy Bird is a mobile game where players control a bird, attempting to fly between columns of green pipes without hitting them. Players tap the screen to make the bird flap its wings and ascend. The goal is to fly between the pipes without hitting them. The game ends when the bird hits a pipe.

		This game was created from scratch without the use of tutorials, game engines, libraries, frameworks, etc. What better way of showing my raw coding skills than by making this classical mobile game. You have to start somewhere!`,
		url: "https://github.com/uplinkx/flappy_bird",
		aspect_ratio: 1/1,
		console: false,
	},
	"mympheus": {
		module: window.mympheus_module,
		title: "Mympheus",
		description: "Demo of a mobile game.",
		url: "https://github.com/uplinkx/2048",
		aspect_ratio: 1008 / 2000,
		console: false,
	},
	"pacman": {
		module: window.pacman_module,
		title: "Pacman",
		description: `Relive the classic arcade game Pacman in this new version, completely coded from scratch. With no tutorials, game engines, libraries, or frameworks used, this game is a testament to my raw coding abilities.

		Guide your spirited hero through the iconic maze with intuitive swipe controls on mobile devices, or opt for the classic keyboard setup using arrow or WASD keys. Immerse yourself in the retro-inspired graphics and gameplay that stay true to the original, as you embark on a thrilling adventure to outsmart the ghostly quartet of Blinky, Pinky, Inky, and Clyde.`,
		url: "https://github.com/uplinkx/pacman",
		aspect_ratio: 224/288,
		console: false,
	},
	"tic_tac_toe": {
		module: window.tic_tac_toe_module,
		title: "Tic-Tac-Toe",
		description: "Face off against a min-max AI in this simple game of tic-tac-toe. Press R to restart the game and try again.",
		url: "https://github.com/uplinkx/tic_tac_toe",
		aspect_ratio: 1/1,
		console: false,
	},
	"taptiles": {
		module: window.taptiles_module,
		title: "TapTiles",
		description: "Tap tiles and chill.",
		url: undefined,
		aspect_ratio: 1008 / 2000,
		console: false,
	},
}
